export enum NotificationType {
    new = 'NEW',
    expiring = 'EXPIRING',
    nonCompliant = 'NON_COMPLIANT',
    newEntity = 'NEW_ENTITY_BODY',
    compliant = 'COMPLIANT',
}

export interface NotificationConfiguration {
    summaryTemplate: string;
    descriptionTemplate: string;
    initEnabled: boolean;
    remindersEnabled: boolean;
}

// Who an email's subject and body are written for. With producer flow on, the producer's text is also
// what the entity reads on its copy of a producer's email.
export enum NotificationAudience {
    entity = 'entity',
    producer = 'producer',
}

// The types a producer can be emailed about. The welcome and compliant emails only go to the entity.
export const PRODUCER_NOTIFICATION_TYPES: readonly NotificationType[] = [
    NotificationType.new,
    NotificationType.expiring,
    NotificationType.nonCompliant,
];

export interface NotificationConfigurationsResponse {
    notifications: Record<NotificationType, NotificationConfiguration>;
    // Absent from servers that predate producer text.
    producerNotifications?: Partial<Record<NotificationType, NotificationConfiguration>>;
}

// Notification types that are one-shot and carry no reminder cadence, so callers reasoning about
// enablement must not treat a false `remindersEnabled` as "off".
const reminderlessNotificationTypes = [
    NotificationType.compliant,
] as const;

export type ReminderlessNotificationType = typeof reminderlessNotificationTypes[number];

export const REMINDERLESS_NOTIFICATION_TYPES: ReadonlySet<NotificationType> =
    new Set(reminderlessNotificationTypes);

export function isReminderlessNotificationType(type: NotificationType): type is ReminderlessNotificationType {
    return REMINDERLESS_NOTIFICATION_TYPES.has(type);
}
